import { Box, BoxProps, Stack, Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

import { useTranslate } from '@/hooks/useTranslate';

import { InputValueHelperRule } from '@/types/common';

import { Icon } from '../Icon/Icon';

type InputRulesHelperTextProps = {
  currentValue?: string | number;
  rules: InputValueHelperRule[];
} & BoxProps;

export function InputRulesHelperText({
  currentValue,
  rules,
  ...props
}: InputRulesHelperTextProps) {
  const { t } = useTranslate();
  const theme = useTheme();
  if (!rules?.length) return null;
  return (
    <Box component="span" display="block" {...props}>
      {rules.map(rule => {
        const isMatched = rule.isMatched(currentValue);

        return (
          <Stack
            key={rule.text}
            alignItems="flex-start"
            justifyContent="flex-start"
            gap={0.25}
            mb={0.5}
            component="span"
          >
            <Icon
              name={isMatched ? 'check' : 'close'}
              color={(theme: Theme) =>
                isMatched ? theme.palette.green[500] : theme.palette.grey[700]
              }
              size={12}
            />
            <Typography
              variant="caption2Bold"
              color={
                isMatched ? theme.palette.green[500] : theme.palette.grey[700]
              }
              component="span"
            >
              {t(rule.i18nKey)}
            </Typography>
          </Stack>
        );
      })}
    </Box>
  );
}
